<template>
  <button class="button" v-on:click="$emit('buttonClick')">
    {{ text }}
  </button>
</template>

<script>
export default {
  props: ['text']
};
</script>

<style lang="scss" scoped>
.button {
  background-color: #150b0b;
  color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  margin: 30px 0 0;
  padding: 15px 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  border: 2px solid transparent;
  text-transform: uppercase;

  &:hover {
    background-color: lighten(#150b0b, 5%);
    border-color: #150b0b;
  }
}
</style>
